const RelatedRecords: React.FC = () => {
  return <div>(必須設定)</div>;
};

export default RelatedRecords;
